import {Util} from "./Util";

export type DownloadManifest = {
  version?: string;
  timestamp?: number;
  windows?: {
    exe?: string;
    msi?: string;
  };
  mac?: {
    universal?: string;
    appleSilicon?: string;
    intel?: string;
    zip?: string;
    dmg?: string;
  };
  chrome?: {
    zip?: string;
  };
};

type ManifestSource = 'remote' | 'env';

const isUsable = (m?: DownloadManifest) => {
  if (!m) return false;
  return Boolean(
    (m.windows && (m.windows.exe || m.windows.msi)) ||
    (m.mac && (m.mac.universal || m.mac.appleSilicon || m.mac.intel || m.mac.zip)) ||
    (m.chrome && (m.chrome.zip))
  );
};

export type LoadedManifest = { manifest: DownloadManifest; source: ManifestSource };

export async function loadDownloadsManifest(): Promise<LoadedManifest> {
  let data: LoadedManifest = {
    manifest: {
      windows: {
        exe: "/releases/Falcon-win.exe",
      },
      mac: {
        zip: "/releases/Falcon-mac.zip",
        dmg: "/releases/Falcon-mac.dmg"
      },
      chrome: {
        zip: "/releases/Falcon-browser-extension.zip"
      }
    },
    source: 'env',
  };

  try {
    const res = await fetch('/downloads.json', {cache: 'no-cache'});
    if (res.ok) {
      const json = (await res.json()) as DownloadManifest;
      if (isUsable(json)) {
        data = {manifest: json, source: 'remote'};
      }
    }
  } catch (error) {
    console.warn('Failed to fetch download manifest:', error);
  }

  try {
    const versionRes = await fetch(Util.apiBaseUrl() + '/api/version', {cache: 'no-cache'});
    if (versionRes.ok) {
      const versionData = await versionRes.json();
      if (data.manifest) {
        data.manifest = {
          ...data.manifest,
          version: versionData.version || '',
          timestamp: versionData.timestamp || 0
        };
      }
    }
  } catch (error) {
    console.warn('Failed to fetch version info:', error);
  }

  return data;
}

export function describeSourceLabel(source: ManifestSource) {
  return source === 'remote' ? 'Latest release' : 'Configured links';
}
